export default __webpack_public_path__ + "static/media/Inventory.03ac3ab5.jpg";